import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { CloudMatrixModule } from '@streamamg/cloud-matrix-lib';
import { dynamicComponentManifests } from './dynamic-component-manifests';
import { CloudPayModule } from '@streamamg/cloud-pay-lib';
import { MenuModule, ServiceLocator } from '@streamamg/amg-common';
import {
  BackToTopModule,
  DynamicComponentLoaderModule,
  LoaderInterceptor,
  LoaderModule,
} from '@streamamg/components-lib';
import { StreamPlayLiveModule, StreamPlayModule } from '@streamamg/stream-play-lib';
import { effects, metaReducers, reducers } from './store';
import { EffectsModule } from '@ngrx/effects';
import { WordpressModule } from '@streamamg/wordpress-lib';
import { configs } from './configs';
import { FooterModule } from './modules/footer/footer.module';
import { HeaderModule } from './modules/header/header.module';
import { LoginModalModule } from './modules/login-modal/login-modal.module';
import { WordpressServiceExtended } from './services/wordpress.api.service';


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    StoreModule.forRoot(reducers, {metaReducers}),
    EffectsModule.forRoot(effects),
    environment.production ? [] : StoreDevtoolsModule.instrument(),
    LoaderModule,
    BackToTopModule,
    StreamPlayModule,
    StreamPlayLiveModule,
    CloudMatrixModule,
    FooterModule,
    DynamicComponentLoaderModule.forRoot(dynamicComponentManifests),
    WordpressModule.forRoot(
      {
        wordpressPath: configs.wordpress.paths.api,
        commonDataUrl: `${configs.wordpress.paths.api}${configs.wordpress.subPaths.commonData}`,
      },
    ),
    CloudPayModule.forRoot(
      {
        url: environment.cloudPay,
        language: 'en',
        isSso: false,
      },
    ),
    LoaderModule.forRoot(
      {
        whitelistStrings: [
          'assets.streamplay.streamamg.com',
        ],
      },
    ),
    HeaderModule,
    LoginModalModule,
    MenuModule.forRoot({
      baseUrl: environment.wordpress.baseUrl,
      endpoint: configs.wordpress.paths.menusApi,
    }),
  ],
  providers: [
    WordpressServiceExtended,
    {provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true},
    {provide: 'googleTagManagerId', useValue: configs.google.gtm},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    // saving a instance of the injector to be able to inject into extended classes
    ServiceLocator.injector = this.injector;
  }
}
